import RenProcessStart from './src/ren-process-start'

RenProcessStart.install = function (Vue) {
  Vue.component(RenProcessStart.name, RenProcessStart)
}

export default RenProcessStart
